import { random } from "../utils/random";
export const arrayRandom = (array) => {
    if (!array.length)
        return undefined;
    return array[random(0, array.length - 1)];
};
